import '../css/footer.css';



const FooterTop = (): JSX.Element => {
    return (
        <div className='containerTop'>
            <div className='wave'></div>
        </div>
    );
};

export default FooterTop;
